import { render, staticRenderFns } from "./IconBookmark.vue?vue&type=template&id=4bfb4ed2&"
import script from "./IconBookmark.vue?vue&type=script&lang=js&"
export * from "./IconBookmark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports